var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatterns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 114,
    viewBox: "0 0 144 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_5409)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.894 42.4535C118.873 54.0246 121.661 64.2307 123.907 75.1527C124.346 77.2855 127.102 78.4649 130.065 77.7969C133.028 77.1286 135.074 74.8513 134.637 72.718C132.508 62.3615 129.749 52.6882 130.716 41.6978C130.912 39.4747 128.644 37.8365 125.659 38.0511C122.672 38.2525 120.089 40.2309 119.894 42.4535Z",
    fill: "#FFCF4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5985 29.5304C62.7475 51.9673 44.4903 78.703 33.3433 103.889C32.3719 106.089 33.881 108.186 36.7112 108.563C39.5413 108.941 42.6308 107.472 43.6022 105.272C54.3818 80.9198 72.0386 55.0621 92.2037 33.3763C94.0249 31.4115 93.5757 28.957 91.2023 27.8986C88.8289 26.8403 85.4202 27.5652 83.5985 29.5304Z",
    fill: "#FFCF4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8832 13.3332C49.4542 16.3008 27.1291 26.7061 8.03887 38.3201C5.5503 39.8432 4.87752 42.4004 6.53467 44.0285C8.19671 45.6686 11.5671 45.7635 14.0589 44.2534C31.4436 33.6705 51.6761 24.0008 73.0141 21.2957C76.0082 20.9167 78.4078 18.8217 78.3716 16.6293C78.3374 14.4365 75.8753 12.9547 72.8832 13.3332Z",
    fill: "#FFCF4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_5409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 127,
    fill: "white",
    transform: "translate(20.4834 113.1) rotate(-103.945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatterns);
export default __webpack_public_path__ + "static/media/patterns.2674046a2e3437b91e3dfefa543e43bd.svg";
export { ForwardRef as ReactComponent };